export const SELL_ORDER = "SELL_ORDER";

export function sellProcessFromOrders(price) {
  return {
    type: SELL_ORDER,
    payload: price
  };
}
